export default __webpack_public_path__ + "static/media/desktop-icon.8bdf1129.svg";